import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import { useCreateCategoryPostMutation } from "../../../../Services/CategoryApi";
import { toast } from "react-toastify";
import LoadingAction from "../../../../components/Loader";

const buttonWidth = {
  width: "100%",
};

const AddCategory = (props) => {
  const { show, handleClose, onCategoryAdded } = props;
  const [addCategories] = useCreateCategoryPostMutation();
  const [categoryName, setCategoryName] = useState("");
  // const [description, setDescription] = useState("");
  const [image, setImage] = useState(null);
  const [showLoader, setShowLoader] = useState(false);

  const handleCategoryNameChange = (e) => {
    setCategoryName(e.target.value);
  };

  // const handleDescriptionChange = (e) => {
  //   setDescription(e.target.value);
  // };

  const handleImageChange = (e) => {
    setImage(e.target.files[0]);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("name", categoryName);
    // formData.append("description", description);
    formData.append("image", image);
    setShowLoader(true)
    addCategories(formData)
      .unwrap()
      .then((res) => {
        toast.success(res?.message);
        onCategoryAdded(res.data);
        handleClose();
        setShowLoader(false)
      })
      .catch((err) => {
        setShowLoader(false)
        toast.error(err?.data?.message);
      });
  };

  return (
    <Modal show={show} onHide={handleClose} centered size="md">
      <Modal.Header closeButton={true} className="border-0 mt-4 pt-0 pb-2">
        <div className="d-flex justify-content-center w-100">
          <Modal.Title className="h5">Add Category</Modal.Title>
        </div>
      </Modal.Header>
      {showLoader && <LoadingAction />}
      <Modal.Body className="px-md-5">
        <form onSubmit={handleSubmit} className="form-login n">
          <div className="mb-4">
            <label className="form-label">Category Name</label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter Category Name"
              value={categoryName}
              onChange={handleCategoryNameChange}
            />
          </div>
          {/* <div className="mb-4">
            <label className="form-label">Description</label>
            <textarea
              className="form-control"
              placeholder="Enter Description"
              value={description}
              onChange={handleDescriptionChange}
            ></textarea>
          </div> */}
          <div className="mb-4">
            <label className="form-label">Image</label>
            <input
              type="file"
              className="form-control"
              onChange={handleImageChange}
            />
          </div>
          <div className="text-center mb-4">
            <button
              type="submit"
              className="btn bg-button py-3 text-white"
              style={buttonWidth}
            >
              Submit
            </button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};

export default AddCategory;
